// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__dF0pN {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 992px) {
  .styles_wrapper__dF0pN {
    justify-content: center;
  }
}

.styles_totalList__DRHts {
  width: 100%;
  max-width: 334px;
}
@media (max-width: 992px) {
  .styles_totalList__DRHts {
    max-width: 100%;
  }
}

.styles_btnWrapper__sn9n\\+ {
  width: 100%;
  max-width: 334px;
  height: 57px;
}
@media (max-width: 992px) {
  .styles_btnWrapper__sn9n\\+ {
    align-self: center;
  }
}
@media (max-width: 576px) {
  .styles_btnWrapper__sn9n\\+ {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/baseContent/burningContent/transactionBlock/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADF;ACoBE;EDvBF;IAOI,uBAAA;EAAF;AACF;;AAGA;EACE,WAAA;EACA,gBAAA;AAAF;ACUE;EDZF;IAKI,eAAA;EACF;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AACF;ACDE;EDHF;IAMI,kBAAA;EAEF;AACF;ACME;EDfF;IAUI,eAAA;EAGF;AACF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  @include lg {\n    justify-content: center;\n  }\n}\n\n.totalList {\n  width: 100%;\n  max-width: 334px;\n\n  @include lg {\n    max-width: 100%;\n  }\n}\n\n.btnWrapper {\n  width: 100%;\n  max-width: 334px;\n  height: 57px;\n\n  @include lg {\n    align-self: center;\n  }\n\n  @include sm {\n    max-width: 100%;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__dF0pN`,
	"totalList": `styles_totalList__DRHts`,
	"btnWrapper": `styles_btnWrapper__sn9n+`
};
export default ___CSS_LOADER_EXPORT___;
